//= require bijou/cjs_shim
//= require bijou/base
//= require bijou/jquery.validate
//= require bijou/smart_form/validation
//= require bijou/smart_form/dropdown

require('./base')
require('../../../../vendor/assets/javascripts/bijou/jquery.validate')
require('./smart_form/validation')
require('./smart_form/dropdown')

;(function ($) {
  'use strict'

  $.widget('bijou.smart_form', $.bijou.base, {
    options: {
      customValidation: {},
      pleaseWait: 'Please wait...'
    },

    _create: function () {
      var _this = this

      this.element.find('select').dropdown({
        form: this.element
      })

      this.element.find('[data-control]').each(function (index, control) {
        var $control = $(control)
        var controlName = $control.data('control')

        if ($.fn[controlName]) {
          $control[controlName]({
            form: _this.element
          })
        }
      })

      this.breakpointEnabled()

      // bentomsett: this disables smart form validation on the new 'personalised
      //   cover' page in Mobius, as this is using its own validation and smart
      //   form was getting in the way.
      if($(".mobius-personalised-cover__form").length === 0) {
        this._setupValidation()
      }

      if (this.options.pleaseWait) {
        this.submitButton = this.element.find('button[type=submit]')
        this.submitButtonLabel = this.submitButton.html()

        // Ensure button is re-enabled when user navigates back.
        // 'pageshow' fires even when the page is retrieved from
        // the browser.s 'bfcache' (previous dom state)
        _this.window.on('pageshow', function () {
          _this.enableButton()
        })
      }
    },

    _setupValidation: function () {
      var _this = this
      var validationConfig

      validationConfig = $.extend({
        submitHandler: function (form, event) {
          var evt = $.Event('validate')
          _this.element.trigger(evt)
          if (evt.result !== false && !evt.isDefaultPrevented()) {
            if (_this.options.pleaseWait) {
              _this.disableButton()
            }
            setTimeout(function () {
              form.submit()
            }, _this.options.pleaseWait ? 100 : 0)
          } else {
            event.stopImmediatePropagation()
          }
        },

        showErrors: function (errorMap, errorList) {
          var evt = $.Event('render_errors')
          evt.errorMap = errorMap
          evt.errorList = errorList
          _this.element.trigger(evt)
          if (evt.result !== false && !evt.isDefaultPrevented()) {
            this.defaultShowErrors()
          }
        },

        errorPlacement: function (error, element) {
          var errorId = error.attr('id');
        
          if (element.closest('.claim').length && _this.options.breakpoint !== 'mobile') {
            element.closest('.control-group').append(error);
          } else if (element.closest('.boolean-group').length && errorId === 'additional_insured_group-error') {
            if (element.closest('.boolean-group').find('#' + errorId).length === 0) {
              element.closest('.boolean-group').append(error);
            }
          } else {
            element.closest('.control').after(error);
          }
        },

        highlight: function (element, errorClass, validClass) {
          var controlBlock = $(element).closest('.control-block')
          $(element).addClass(errorClass).removeClass(validClass)
          controlBlock.addClass(errorClass).removeClass(validClass)

          $(element).trigger('validationchange', [false])
        },

        unhighlight: function (element, errorClass, validClass) {
          var controlBlock = $(element).closest('.control-block')
          var optional = _this._validator.optional(element)
          $(element).removeClass(errorClass).toggleClass(validClass, !optional)
          controlBlock.removeClass(errorClass).toggleClass(validClass, !optional)

          $(element).trigger('validationchange', [true])
        },

        onfocusout: false
      }, this.options.customValidation)

      var validator = this._validator = this.element.validate(validationConfig)

      var claimGroups = _this.element.find('.claim')

      this._onBreakpoint('mobile', function () {
        var inError = claimGroups.filter(function () {
          return $(this).has('label.error').length
        })

        if (inError.length) {
          inError.find('label.error').remove()
          inError.find(':input').each(function () {
            validator.element(this)
          })
        }
      }, true)

      // change event doesn't bubble properly in FF 4-9
      // so we must attach event to each input
      this._on(this.element.find('select'), {
        change: function (e) {
          if (_this._validator.submitted[e.currentTarget.name]) {
            $(e.currentTarget).valid()
          }
        }
      })

      // Trigger validation when 'input' event fires.
      // This makes validation work when pasting in fields
      // and when using autocomplete on touch devices.
      this._on({
        'input input': function (e) {
          if (_this._validator.submitted[e.currentTarget.name]) {
            $(e.currentTarget).valid()
          }
        }
      })
    },

    disableButton: function () {
      this.submitButton.prop('disabled', true).html(this.options.pleaseWait)
    },

    enableButton: function () {
      this.submitButton.prop('disabled', false).html(this.submitButtonLabel)
    },

    /** clears field value
     * @param {HTMLElement|jQuery} element Subject input element or a collection of elements
     */
    clearFieldValue: function (element) {
      $(element).each(function () {
        var input = $(this)
        if (input.is(':text, input[type=hidden], textarea')) {
          input.val('')
        } else if (input.is('select')) {
          input.prop('selectedIndex', 0)
        } else if (input.is(':radio, :checkbox')) {
          input.prop('checked', false)
        }
      })
    },

    /** sets field value
     * @param {HTMLElement|jQuery} element Subject input element or collection
     * @param {String|Array} value Value to be set
     *
     * Note: use an array of {String} values for a set of checkboxes
     */
    setFieldValue: function (element, value) {
      var $input = $(element)
      if ($input.is(':text, input[type=hidden], textarea, select')) {
        $input.val(value)
      } else if ($input.is(':radio')) {
        $input.prop('checked', $input.attr('value') === value)
      } else if ($input.is(':checkbox')) {
        if ($.type(value) === 'array') {
          $input.prop('checked', $.inArray($input.attr('value'), value) >= 0)
        } else {
          $input.prop('checked', $input.attr('value') === value)
        }
      }
    }

  })
}(window.jQuery))
